import { api } from "data";
import { baseApiClient } from "data/modules/api/api.client";
import { logError } from "utils/error";
import { hasSubscriptionStarted } from "../../../utils/ManageBookings.utils";
import { TELEGRAM_GROUP_STATES } from "../modules/TelegramGroupState/TelegramGroupState.constants";

export const showTelegramActions = (
  isTelegramCommunity,
  record,
  isSubscription = false
) => {
  const showActions =
    isTelegramCommunity &&
    record?.tg_link_status &&
    record.tg_link_status !== TELEGRAM_GROUP_STATES.GROUP_EXIT;
  if (!isSubscription) return showActions;
  return showActions && hasSubscriptionStarted(record.subscription_start_date);
};

export const banTelegramUser = async ({ record, onSuccess, onFailure }) => {
  if (!record) return;
  try {
    const transaction_uuid =
      record?.transaction_uuid || (record?.transactions || [])?.at(-1)?.uuid; // latest transaction
    const response = await baseApiClient.post(api.telegram_ban, {
      transaction_uuid,
    });
    if (onSuccess) onSuccess(response.data);
  } catch (error) {
    logError({
      error,
      occuredAt:
        "src/features/Crm/modules/Bookings/modules/ManageBookings/modules/TelegramBookings/utils/TelegramBookings.utils.js",
      when: "Error while removing telegram user",
    });
    if (onFailure) onFailure(error);
  }
};
